import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import $ from "jquery";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isEmail,
  isSingleSelect,
  isPhone,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "customer";
var moduleName = "Customers";
var modulePath = "/clientpanel/customers";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (this.props.match.path === "/clientpanel/customers/edit/:EditID") {
      editID = this.props.match.params.EditID;
    }
    this.state = {
      editID: editID,
      pageloading: false,
      postdata: {
        customerFirstName: "",
        customerLastName: "",
        customerPassword: "",
        customerCPassword: "",
        customerEmail: "",
        customerMobile: "",
        customerBirthDate: "",
        customerStatus: "",
        customerAllowPromotion: "",
        action: "add",
      },
      loading: true,
      formpost: [],
      companyDetail: [],
    };
  }
  componentDidMount() {
   if (this.state.editID !== "") {
      var params = {
        params:'' ,
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var customerStatus =
            result.customerStatus === "A" ? "Active" : "In Active";
          var status =
            result.customerStatus !== "" && result.customerStatus !== null
              ? {
                  label: customerStatus,
                  value: result.customerStatus,
                }
              : "";
          var clientupdatedata = {
            customerFirstName: result.customerFirstName,
            customerLastName: result.customerLastName,
            customerEmail: result.customerEmail,
            customerMobile: result.customerMobile,
            customerBirthDate:
              result.customerBirthDate !== "" &&
              result.customerBirthDate !== null
                ? new Date(result.customerBirthDate)
                : "",
            customerStatus: status,
            customerPassword: "",
            customerCPassword: "",
            customerAllowPromotion:result?.customerAllowPromotion ?? false,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {};

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      customerFirstName: postData.customerFirstName,
      customerLastName: postData.customerLastName,
      customerPassword: postData.customerPassword,
      customerEmail: postData.customerEmail,
      customerMobile: postData.customerMobile,
      customerStatus: postData.customerStatus?.value ?? "A",
      customerBirthDate: postData.customerBirthDate !== "" ? format(postData.customerBirthDate, "yyyy-MM-dd") : "",
      customerAllowPromotion:postData.customerAllowPromotion
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"customers"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>

                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

const minLength = (customerPassword, length) =>
  customerPassword.length >= length || customerPassword === ""
    ? null
    : "Password must be at least 6 characters.";
const areSame = (customerPassword, customerCPassword) =>
  customerPassword === customerCPassword ? null : "Password do not match.";

function validationConfig(props) {
  const { customerFirstName, customerPassword, customerCPassword, customerMobile, customerEmail, customerStatus } =
    props.fields;
  if (props.fields.action === "add") {
    return {
      fields: [
        "customerFirstName",
        "customerPassword",
        "customerCPassword",
        "customerMobile",
        "customerEmail",
        "customerStatus",
      ],

      validations: {
        customerFirstName: [[isEmpty, customerFirstName]],
        customerPassword: [
          [isEmpty, customerPassword],
          [minLength, customerPassword, 6],
        ],
        customerCPassword: {
          rules: [
            [areSame, customerPassword, customerCPassword],
            [isEmpty, customerCPassword],
          ],
          fields: ["customerPassword", "customerCPassword"],
        },
        customerEmail: [
          [isEmpty, customerEmail],
          [isEmail, customerEmail],
        ],
        customerMobile: [[isPhone, customerMobile]],
        customerStatus: [[isSingleSelect, customerStatus]],
      },
    };
  } else {
    return {
      fields: [
        "customerFirstName",
        "customerPassword",
        "customerCPassword",
        "customerMobile",
        "customerEmail",
        "customerStatus",
      ],

      validations: {
        customerFirstName: [[isEmpty, customerFirstName]],
        customerPassword: [[minLength, customerPassword, 6]],
        customerCPassword: {
          rules: [[areSame, customerPassword, customerCPassword]],
          fields: ["customerPassword", "customerCPassword"],
        },
        customerMobile: [[isPhone, customerMobile]],
        customerEmail: [
          [isEmpty, customerEmail],
          [isEmail, customerEmail],
        ],
        customerStatus: [[isSingleSelect, customerStatus]],
      },
    };
  }
}

class PostForm extends Component {
  
  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeCheck(name, event) {
    var value = event.target.checked;
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgName,
      errMsgPassword,
      errMsgConfirmPassword,
      errMsgEmail,
      errMsgPhone,
      errMsgStatus = "";
    if ($validation.customerFirstName.error.reason !== undefined) {
      errMsgName = $validation.customerFirstName.show && (
        <span className="error">{$validation.customerFirstName.error.reason}</span>
      );
    }
    if ($validation.customerPassword.error.reason !== undefined) {
      errMsgPassword = $validation.customerPassword.show && (
        <span className="error">{$validation.customerPassword.error.reason}</span>
      );
    }
    if ($validation.customerCPassword.error.reason !== undefined) {
      errMsgConfirmPassword = $validation.customerCPassword.show && (
        <span className="error">{$validation.customerCPassword.error.reason}</span>
      );
    }
    if ($validation.customerStatus.error.reason !== undefined) {
      errMsgStatus = $validation.customerStatus.show && (
        <span className="error">{$validation.customerStatus.error.reason}</span>
      );
    }
    if ($validation.customerEmail.error.reason !== undefined) {
      errMsgEmail = $validation.customerEmail.show && (
        <span className="error">{$validation.customerEmail.error.reason}</span>
      );
    }
    if ($validation.customerMobile.error.reason !== undefined) {
      errMsgPhone = $validation.customerMobile.show && (
        <span className="error">{$validation.customerMobile.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgName !== "" &&
                  errMsgName !== false &&
                  errMsgName !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="customerFirstName"
                value={fields.customerFirstName}
                {...$field("customerFirstName", (e) =>
                  onChange("customerFirstName", e.target.value)
                )}
              />
              <label htmlFor="customerFirstName">
                First Name <span className="error">*</span>
              </label>
              {errMsgName}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="customerLastName"
                value={fields.customerLastName}
                {...$field("customerLastName", (e) =>
                  onChange("customerLastName", e.target.value)
                )}
              />
              <label htmlFor="customerLastName">Last Name</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgEmail !== "" &&
                  errMsgEmail !== false &&
                  errMsgEmail !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="customerEmail"
                value={fields.customerEmail}
                {...$field("customerEmail", (e) => onChange("customerEmail", e.target.value))}
              />
              <label htmlFor="customerEmail">
                Email ID <span className="error">*</span>
              </label>
              {errMsgEmail}
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-4 form-password-toggle">
              <div className="input-group input-group-merge">
                <div className="form-floating form-floating-outline">
                  <input
                    type="password"
                    id="customerPassword"
                    className={
                      errMsgPassword !== "" &&
                      errMsgPassword !== false &&
                      errMsgPassword !== undefined
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    value={fields.customerPassword}
                    {...$field("customerPassword", (e) =>
                      onChange("customerPassword", e.target.value)
                    )}
                  />
                  <label htmlFor="customerPassword">
                    Password <span className="error">*</span>
                  </label>
                  {errMsgPassword}
                </div>
                <span
                  className="input-group-text rounded-end cursor-pointer"
                  id="basic-default-password4"
                  style={{ height: "49px" }}
                >
                  <i className="mdi mdi-eye-off-outline"></i>
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-4 form-password-toggle">
              <div className="input-group input-group-merge">
                <div className="form-floating form-floating-outline">
                  <input
                    type="password"
                    id="customerCPassword"
                    className={
                      errMsgConfirmPassword !== "" &&
                      errMsgConfirmPassword !== false &&
                      errMsgConfirmPassword !== undefined
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    value={fields.customerCPassword}
                    {...$field("customerCPassword", (e) =>
                      onChange("customerCPassword", e.target.value)
                    )}
                  />
                  <label htmlFor="customerCPassword">
                    Confirm Password <span className="error">*</span>
                  </label>
                  {errMsgConfirmPassword}
                </div>
                <span
                  className="input-group-text rounded-end cursor-pointer"
                  id="basic-default-password3"
                  style={{ height: "49px" }}
                >
                  <i className="mdi mdi-eye-off-outline"></i>
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgPhone !== "" &&
                  errMsgPhone !== false &&
                  errMsgPhone !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="customerMobile"
                value={fields.customerMobile}
                {...$field("customerMobile", (e) => onChange("customerMobile", e.target.value))}
              />
              <label htmlFor="customerMobile">Phone No.</label>
              {errMsgPhone}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.customerBirthDate}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
                placeholderText="Date Of Birth"
                onChange={this.handleChange.bind(this, "customerBirthDate")}
              />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-check form-check-inline mt-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="customerAllowPromotion"
                checked={fields.customerAllowPromotion}
                onChange={this.handleChangeCheck.bind(
                  this,
                  "customerAllowPromotion"
                )}
              />
              <label
                className="form-check-label"
                htmlFor="customerAllowPromotion"
              >
                Allow Promotion
              </label>
            </div>
          </div>
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-4 error-select error"
                : "col-md-4"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.customerStatus}
                onChange={this.handleChange.bind(this, "customerStatus")}
                placeholder="Select Status *"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div
              className="pt-1 pb-4 pr-2 text-end"
              style={{ paddingRight: "20px" }}
            >
              <button
                type="button"
                disabled={this.props.btndisabled}
                className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
                onClick={(e) => {
                  e.preventDefault();
                  if (!this.props.btndisabled) {
                    this.props.$submit(onValid, onInvalid);
                  }
                }}
              >
                Submit
              </button>
              <Link to={modulePath}>
                <button
                  type="reset"
                  className="btn btn-label-secondary waves-effect"
                >
                  Cancel
                </button>
              </Link>
            </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
